import React, { useEffect, useState } from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import { Box, CircularProgress, Link, Paper, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';

import * as publicOfferFeedService from '~/services/PublicOfferFeedService';
import { AdCustomer } from '~/services/PublicOfferFeedService';

const columns: Array<GridColDef> = [
  {
    field: 'descriptiveName',
    headerName: 'Account Name',
    flex: 2,
    renderCell: (params) => (
      <Link component={RouterLink} to={`/marketing/google-ads/customer/${params.row.id}/campaign`} underline="hover">
        {params.value}
      </Link>
    ),
  },
  {
    field: 'id',
    headerName: 'Account ID',
    flex: 1,
  },
];

function CustomerListView() {
  const [customers, setCustomers] = useState<Array<AdCustomer>>([]);
  const [fetchingState, setFetchingState] = useState<Utils.FetchingState>('idle');

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setFetchingState('loading');
        const response = await publicOfferFeedService.getCustomers();
        setCustomers(response.result);
        setFetchingState('success');
      } catch (err) {
        console.error(err);
        setFetchingState('failed');
      }
    };

    fetchCustomers();
  }, []);

  if (fetchingState === 'loading') {
    return (
      <Box p={2} display="flex" justifyContent="center">
        <CircularProgress variant="indeterminate" />
      </Box>
    );
  }

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>
        Google Ads Accounts
      </Typography>

      <DataGrid
        rows={customers}
        columns={columns}
        pagination
        paginationMode="client"
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        getRowId={(row) => row.id}
        slots={{ pagination: GridPagination }}
        disableColumnFilter
        disableColumnMenu
        disableRowSelectionOnClick
        autoHeight
      />
    </Paper>
  );
}

export default CustomerListView;
